import axios from 'axios'
import queryString from 'query-string'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { BudgetRequestListResponse } from 'src/models/budgetRequest.models'
import { PaginationResponse } from 'src/models/pagination.models'
import { RootState } from 'src/redux/createRootReducer'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'
import { GetBudgetRequestsRequest } from 'src/requests/getBudgetRequests.request'

export const GET_BUDGET_REQUESTS_INIT =
  'data/budgetRequests/GET_BUDGET_REQUESTS_INIT'
export const GET_BUDGET_REQUESTS_SUCCESS =
  'data/budgetRequests/GET_BUDGET_REQUESTS_SUCCESS'
export const GET_BUDGET_REQUESTS_FAILURE =
  'data/budgetRequests/GET_BUDGET_REQUESTS_FAILURE'

export interface GetBudgetRequestsInitPayload {
  queryParameters: GetBudgetRequestsRequest
}

export interface GetBudgetRequestsSuccessPayload {
  budgetRequest: BudgetRequestListResponse[]
  pagination: PaginationResponse
  queryParameters: GetBudgetRequestsRequest
}

export interface GetBudgetRequestsFailurePayload {
  queryParameters: GetBudgetRequestsRequest
}

export interface GetBudgetRequestsInitAction {
  type: typeof GET_BUDGET_REQUESTS_INIT
  payload: GetBudgetRequestsInitPayload
}
export interface GetBudgetRequestsSuccessAction {
  type: typeof GET_BUDGET_REQUESTS_SUCCESS
  payload: GetBudgetRequestsSuccessPayload
}
export interface GetBudgetRequestsFailureAction {
  type: typeof GET_BUDGET_REQUESTS_FAILURE
  payload: GetBudgetRequestsFailurePayload
}

export type GetBudgetRequestsActions =
  | GetBudgetRequestsInitAction
  | GetBudgetRequestsSuccessAction
  | GetBudgetRequestsFailureAction

const createGetBudgetRequestsInitAction = (
  payload: GetBudgetRequestsInitPayload,
): GetBudgetRequestsInitAction => ({
  type: GET_BUDGET_REQUESTS_INIT,
  payload,
})
const createGetBudgetRequestsSuccessAction = (
  payload: GetBudgetRequestsSuccessPayload,
): GetBudgetRequestsSuccessAction => ({
  type: GET_BUDGET_REQUESTS_SUCCESS,
  payload,
})
const createGetBudgetRequestsFailureAction = (
  payload: GetBudgetRequestsFailurePayload,
): GetBudgetRequestsFailureAction => ({
  type: GET_BUDGET_REQUESTS_FAILURE,
  payload,
})

export const getBudgetRequests = (
  queryParameters: GetBudgetRequestsRequest,
): ThunkAction<
  Promise<GetBudgetRequestsSuccessAction | GetBudgetRequestsFailureAction>,
  RootState,
  void,
  GetBudgetRequestsActions
> => {
  return async (
    dispatch: ThunkDispatch<RootState, void, GetBudgetRequestsActions>,
    getState: () => RootState,
  ): Promise<
    GetBudgetRequestsSuccessAction | GetBudgetRequestsFailureAction
  > => {
    dispatch(createGetBudgetRequestsInitAction({ queryParameters }))
    return axios
      .get<GetBudgetRequestsSuccessPayload>(
        `/budgetrequests?${queryString.stringify(queryParameters)}`,
        selectAuthedJsonApiRequestConfig(getState()),
      )
      .then(
        (response) => {
          return dispatch(
            createGetBudgetRequestsSuccessAction({
              ...response.data,
              queryParameters,
            }),
          )
        },
        (err) => {
          return dispatch(
            createGetBudgetRequestsFailureAction({
              ...err.response.data,
              queryParameters,
            }),
          )
        },
      )
  }
}
export const GET_BUDGET_REQUEST_INIT =
  'data/budgetRequests/GET_BUDGET_REQUEST_INIT'
export const GET_BUDGET_REQUEST_SUCCESS =
  'data/budgetRequests/GET_BUDGET_REQUEST_SUCCESS'
export const GET_BUDGET_REQUEST_FAILURE =
  'data/budgetRequests/GET_BUDGET_REQUEST_FAILURE'

export type GetBudgetRequestSuccessPayload = {
  budgetRequest: BudgetRequestListResponse
  queryParameters: GetBudgetRequestsRequest
  pagination: PaginationResponse
}

export interface GetBudgetRequestInitAction {
  type: typeof GET_BUDGET_REQUEST_INIT
}
export interface GetBudgetRequestSuccessAction {
  type: typeof GET_BUDGET_REQUEST_SUCCESS
  payload: GetBudgetRequestSuccessPayload
}
export interface GetBudgetRequestFailureAction {
  type: typeof GET_BUDGET_REQUEST_FAILURE
  payload: unknown
}

export type GetBudgetRequestActions =
  | GetBudgetRequestInitAction
  | GetBudgetRequestSuccessAction
  | GetBudgetRequestFailureAction

const createGetBudgetRequestInitAction = (): GetBudgetRequestInitAction => ({
  type: GET_BUDGET_REQUEST_INIT,
})
const createGetBudgetRequestSuccessAction = (
  payload: GetBudgetRequestSuccessPayload,
): GetBudgetRequestSuccessAction => ({
  type: GET_BUDGET_REQUEST_SUCCESS,
  payload,
})
const createGetBudgetRequestFailureAction = (
  response: unknown,
): GetBudgetRequestFailureAction => ({
  type: GET_BUDGET_REQUEST_FAILURE,
  payload: response,
})

export const getBudgetRequest = (
  creditCardId: string,
): ThunkAction<
  Promise<GetBudgetRequestSuccessAction | GetBudgetRequestFailureAction>,
  RootState,
  void,
  GetBudgetRequestActions
> => {
  return async (
    dispatch: ThunkDispatch<RootState, void, GetBudgetRequestActions>,
    getState: () => RootState,
  ): Promise<GetBudgetRequestSuccessAction | GetBudgetRequestFailureAction> => {
    dispatch(createGetBudgetRequestInitAction())
    return axios
      .get<GetBudgetRequestSuccessPayload>(
        `/budgetrequests/${creditCardId}`,
        selectAuthedJsonApiRequestConfig(getState()),
      )
      .then(
        async (response) => {
          // dispatch(getCreditCardsStatisticsActiveBudgetCount([response.data.creditCard.id]))
          // dispatch(getCreditCardsStatisticsBudgetCount([response.data.creditCard.id]))
          // dispatch(getCreditCardsStatisticsActiveVcnCount([response.data.creditCard.id]))
          // dispatch(getCreditCardsStatisticsVcnCount([response.data.creditCard.id]))
          return dispatch(createGetBudgetRequestSuccessAction(response.data))
        },
        async (err) => {
          return dispatch(
            createGetBudgetRequestFailureAction(err.response.data),
          )
        },
      )
  }
}

export const REMOVE_BUDGET_REQUEST = 'data/budgetRequests/REMOVE_BUDGET_REQUEST'

export interface RemoveBudgetRequestAction {
  type: typeof REMOVE_BUDGET_REQUEST
  payload: {
    budgetRequestId: string
  }
}

export const removeBudgetRequest = (
  budgetRequestId: string,
): RemoveBudgetRequestAction => ({
  type: REMOVE_BUDGET_REQUEST,
  payload: {
    budgetRequestId,
  },
})
